<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
           <li class="nav-item signup-btn">
          <a class="nav-link button" data-toggle="modal" routerLink="/login">Start for free</a>
          </li>
          <li class="nav-item login-btn">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="partner-main-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- <img src="assets/img/learning.svg" alt=""> -->
        <h2>We are experts: <br>We are <span class="freelaner-txt">Crafttor Workspace</span></h2>
        <p>Enthusiastic champions of our expertise.</p>
        <p style="padding-top: 0px;">Extending an invitation to like-minded creative people.</p>
        <div class="btn-wrapper">
          <a class="button enterprise-buy-now" style="background: #000000; color: #ffffff;" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
          <a class="button light-blue-btn" style="color: #2d7cff;" routerLink="/login">Start for free</a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="features-sections partner-feature-section" style="margin-top: -60px;">
  <h3 class="main-title"></h3>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12 central-txt">
        <h3 class="header-text-center">A workspace connects <br>every detail to the bigger picture</h3>

        <div class="row" style="display: flex;">
          <img class="experts-img col-sm-4" src="assets/img/ab.png">

          <img class="experts-img col-sm-4" src="assets/img/wrk.png">

          <img class="experts-img col-sm-4" src="assets/img/spc.png">
        </div>

        <div class="text-center about-workspace-details">
          <p class="workspace-about-txt">and is a multifaceted environment designed to optimise both productivity and strategic alignment within an organisation. <br><br>
          At its core, Crafttor Workspace is meticulously organised to facilitate efficient storage and retrieval of resources. From filing cabinets and shelves to cloud-based storage solutions and assets management systems, every aspect of storage is thoughtfully planned to ensure that information and materials are accessible to those with whom the assets are shared or who need them within the team. This accessibility promotes collaboration and knowledge sharing among team members, as individuals can easily locate and leverage relevant resources to support their work.
          <br><br>
          In addition to storage, the collaborative aspect of the Crafttor Workspace is equally essential. It manages team collaborations at real time. The tools are designed to foster teamwork, creativity, and innovation by providing opportunities for collaboration among team members. <br><br>
          There are other important aspects of Crafttor Workspace like approval systems, search, content library, plugin assets resolution settings, team management, profile management, etc which makes this Workspace stands at a position to prove excellence among the DAM systems. There are more features to explore so go for it <a style="color: #2d7cff;" routerLink="/login">https://workspace.crafttor.com/login</a> and share your amazing experiences using Workspace at <b>info@crafttor.com</b>.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="designed-area comparison-feedbacks" style="padding-top: 120px;">
  <div class="container">
    <h3>Creativity sparks <br>amidst an organised workspace</h3>
    <div class="row">
      <div class="col-md-4">
        <div class="review-box workspace-color">
          <div class="review-icon-box-3">

          </div>
          <p>Finding and storing design assets is easy with Crafttor Workspace.</p>
          <ul>
            <li>Versioning & organised.</li>
            <li>Team Collaboration.<br>(Increase revenue)</li>
            <li>Better management of assets.<br>(Increase productivity)</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div class="review-box workspace-color-black">
          <div class="review-icon-box-4">

          </div>
          <p>Impact drawn by Crafttor Workspace.</p>
          <ul>
            <li>Design consistency.</li>
            <li>Reduced expenses for secured storage.</li>
            <li>Increase productivity.</li>
            <li>Better team collaboration.</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div class="review-box workspace-color">
          <div class="review-icon-box-5">

          </div>
          <p>Design community is huge, and so are our solutions.</p>
          <ul>
            <li>Cloud storage.</li>
            <li>Custom tagging.</li>
            <li>Secure & sharing.</li>
            <li>Design collaboration.</li>
            <li>Marketplace.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="features-sections creative-work-details">
  <div class="container">
    <h3>Some Features <br>Video Shots</h3>
    <div class="row">
      <div class="col-sm-7">
        <video autoplay loop [muted]="'muted'" class="kaleidoscope-img" controls>
          <source src="https://marketplace-crafttor-assets.s3.ap-south-1.amazonaws.com/plugin-tagging.mp4" type="video/mp4">
        </video>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-4 d-flex align-items-center justify-content-center">
        <h4>Effortlessly Tag your Assets in the Plugin</h4>
      </div>
    </div>

    <div class="row second-sec">
      <div class="col-sm-4 d-flex align-items-center justify-content-center">
        <h4>Seamless Versioning for your Assets in the Plugin</h4>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-7">
        <video autoplay loop [muted]="'muted'" class="kaleidoscope-img" controls>
          <source src="https://marketplace-crafttor-assets.s3.ap-south-1.amazonaws.com/plugin-version.mp4" type="video/mp4">
        </video>
      </div>
    </div>
  </div>
</section>

<section class="team-members founders-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-5" style="margin-top: -70px;">
        <h2 class="team-head-title">Meet the Founders</h2>
        <div class="founders-info">
          <div class="" *ngIf="showSandeepInfo">
            <span>
              Sandeep has worked as a designer for over 15 years, serving as Head of Design and leading various teams and projects throughout his career.<br><br>While collaborating with different teams, Sandeep identified a significant inefficiency: designers often had to leave the tools they were working in to access assets or files from platforms like Google Drive, Dropbox, etc. This process was time-consuming and reduced productivity. From this experience, Sandeep realised the need for an organised platform for sharing and collaboration to boost productivity and achieve faster results.<br><br>At Crafttor Workspace, Virk oversees overall product management and strategies, playing a key role in all design aspects, including marketplace illustrations and icons.
            </span>
            <button style="width: 100%;" type="button" class="btn schedule-call" name="button" (click)="openLetsTalkDialog(letsTalk)">Schedule a call</button>
          </div>
          <span *ngIf="!showSandeepInfo">Worked as a Software Engineer with different companies, Akash, brings a wealth of experience and expertise to products he undertakes. With a background in building products from inception to market launch, Akash possesses a deep understanding of various technologies, including AWS solutions, Java, Android, iOS, Kotlin, Angular, etc. His proficiency extends beyond mere coding. <br><br> At Workspace, Akash controls the overall handling of product development.<br><br>Akash is a serial entrepreneur and a techie who builds products in a better way.</span>
        </div>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6 meet-the-founders-pics">
        <div class="meet-founders">
          <div class="team-members-box text-center" (click)="highlight('sandy')" [class.highlighted]="selectedMember === 'sandy'">
            <img src="assets/img/sandeep.jpeg" alt="" width="180" style="border-radius:20%;">
            <h3 class="">Sandeep Virk</h3>
            <p>Founder </p><br>
            <a rel="nofollow" href="https://www.linkedin.com/in/virksandeep/" target=”_blank” alt="twitter"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
          </div>
          <div class="team-members-box text-center" (click)="highlight('akash')" [class.highlighted]="selectedMember === 'akash'">
            <img src="assets/img/akii.jpeg" alt="" width="180" style="border-radius:20%;">
            <h3 class="">Akash Bariar</h3>
            <p>Co-Founder </p><br>
            <a rel="nofollow" href="https://www.linkedin.com/in/bariar-singh-akash-101b153a/" target=”_blank” alt="twitter"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="partner-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 text-center">
        <h3>Crafttor for All</h3>
        <p>Crafttor is a versatile and flexible platform designed to empower creatives and teams save time and money from an unorganised platform.</p>
        <a class="button demo-btn" style="color: #ffffff; background: #000000;" (click)="openLetsTalkDialog(letsTalk)">Connect with us</a>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
  				<img src="assets/img/logo.svg">
  				<p>Digital assets management</p>
  				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
  			</div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a routerLink="/home">Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>

        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
      </div>

      <div class="col-sm-12 text-center">
  			<small>&copy; 2025 Crafttor. All rights reserved</small>
  		</div>
    </div>
  </div>
</footer>

<ng-template #letsTalk let-letsTalk>
    <div class="custom-dialog custom-dialog-centered sign-up" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="letsTalk.close()">
          </button>
        <div class="modal-body">
      <h2>Let's talk!</h2>
      <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
      <div class="form-wrapper">
        <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
          <div class="col-md-6">
          <label class="form-label">First Name<span>*</span></label>
          <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
          First Name is required
        </span>
          </div>
          <div class="col-md-6">
          <label class="form-label">Last Name<span>*</span></label>
          <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
          Last Name is required
        </span>
          </div>
          <div class="col-12">
          <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
          <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
          Email is required
        </span>
        <span class="text-danger error-text"
        *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
        Email is not valid
      </span>
          </div>
          <div class="col-12">
          <label for="company" class="form-label">Company<span>*</span></label>
          <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
          Company Name is required
        </span>
          </div>

          <div class="col-md-12" style="display: none;">
            <label class="form-label" for="textarea">Message</label>
            <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
            Message is required
          </span>
          </div>


          <div class="col-12">
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
        </form>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #selectDate let-selectDate>
    <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="selectDate.close()">
          </button>
        <div class="modal-body">
      <h6>{{thankYouText}}</h6>
      <h6>(IST)</h6>
      <div class="form-wrapper">
        <ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
          <li *ngIf="showDate">
            <div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
              <!-- <div class="date-list-day" style="background: #f9f9f9">
                <a href="javascript:;">{{slots.day}}</a>
              </div> -->
              <div class="">
                <a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
              </div>
              <!-- <a href="javascript:;">{{slots.month}}</a> -->
            </div>
          </li>
        </ul>

        <div *ngIf="!showDate" class="selected-date">
          <div class="date-list-days">
            <a href="javascript:;">{{shownDay}}</a>
          </div>
          <div style="padding-top:10px;" class="">
            <a href="javascript:;">{{shownDate}}</a>
          </div>
          <!-- <a href="javascript:;">{{shownMonth}}</a> -->
        </div>

        <p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

        <h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

        <ul *ngFor="let time of availableTimeSlots; let i = index">
          <li *ngIf="showTime">
            <div class="time-list" (click)="selectTimeSales(time)">
              <div style="text-align: center;" class="">
                <a href="javascript:;">{{time}}</a>
              </div>
            </div>
          </li>
        </ul>
        <div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
          <a href="javascript:;">{{shownTime}}</a>
        </div>
        <p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
        <p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>

<ng-template #showloader let-showloader>
  <div class="custom-dialog custom-dialog-centered show-loader" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
        <h6 style="font-size: 16px;">Please wait</h6>
        <p>Confirming your meeting time..</p>
      </div>
  </div>
</div>
</ng-template>


<ng-template #thankyou let-thankyou>
  <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5>Thank you <br>Your meeting is confirmed. </h5>
          <div class="conver-grid">
            <div class="img-wrapper">
              <img src="" >
              <img src="assets/img/tick.png" class="tick">
            </div>
          <p>You are meeting with</p>
          <h4>Sandeep Virk</h4>
          </div>
      <div class="invitation-wrapper">
        <div class="">You will receive a meeting invitation shortly</div>
          <table>
          <tbody>
            <tr>
              <th>Event</th>
              <td>Crafttor intro with Sandeep</td>
            </tr>
            <!-- <tr>
              <th>Time</th>
              <td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
            </tr> -->
            <tr>
              <th>Guest</th>
              <td>{{userName}}<span><a>{{userEmail}}</a></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
    margin-top: 20px;" (click)="closeThankDialog()">Close</button>
    </div>
  </div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>
